import { REACT_QUERY_KEYS } from '@/constants'
import type { FetchPartnerToSubPartnersQuery } from '@/features/partner-to-sub-partners/api'

export const subPartnersQueryKeys = {
  all: [REACT_QUERY_KEYS.SUB_PARTNERS] as const,
  select: (query: FetchPartnerToSubPartnersQuery) =>
    [...subPartnersQueryKeys.all, 'select', query] as const
}
